const isValidValue = (key, parameters) => {
  return parameters[key] !== null &&
    parameters[key] !== undefined &&
    parameters[key] !== ''
}

const buildSeoUrl = (path, params) => {
  if (!params) return path

  const paramList = Object.keys(params)
    .filter(key => isValidValue(key, params))
    .map(key => `${encodeURIComponent(params[key])}`)
  return `${path}/${paramList.join('/')}`
}

export default buildSeoUrl
